import { Auth } from '@aws-amplify/auth';
import { signV4AwsApiAxiosRequest } from '@iotv/auth';
import axios from 'axios';
const debug = process.env.REACT_APP_DEBUG && false;
const { REACT_APP_AWS_DEFAULT_REGION = 'ap-southeast-2' } = process.env;
class HttpApiGateway {
    send = async ({ host, path, method, data }) => {
        let result = { err: null, data: null };
        try {
            const credentials = await Auth.currentUserCredentials();
            const { accessKeyId: AccessKeyId, secretAccessKey: SecretAccessKey, sessionToken: SessionToken, expiration: Expiration } = credentials;
            const protocol = `https`;
            const amplifyCredentials = { AccessKeyId, SecretAccessKey, SessionToken, Expiration };
            const axiosRequestConfig = await signV4AwsApiAxiosRequest({
                credentials: amplifyCredentials,
                region: REACT_APP_AWS_DEFAULT_REGION,
                path,
                host,
                method,
                protocol,
                data,
            });
            delete axiosRequestConfig.headers?.host; // xhr will refuse and show err in console
            const res = await axios(axiosRequestConfig);
            debug && console.log('axiosRequestConfig', axiosRequestConfig);
            if (res.status === 200 && res.data) {
                debug && console.log('RES', res.data);
                result = res.data;
            }
        }
        catch (e) {
            result.err = e;
        }
        return result;
    };
    post = async ({ host, path, data }) => {
        const method = 'POST';
        let result = await this.send({ host, path, method, data });
        debug && console.log(`${path} res`, { result });
        return result;
    };
    get = async ({ host, path, data }) => {
        const method = 'GET';
        let result = await this.send({ host, path, method, data });
        debug && console.log(`${path} res`, { result });
        return result;
    };
}
export default new HttpApiGateway();
